import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { Tab, Header, Segment } from 'semantic-ui-react';
import { fetchLanguages, fetchDocumentTypes, fetchDocumentStatuses, fetchCertificateReasons } from '../../Lookups/util';

import TableRequests from './TableRequests';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class DocumentRequests extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filterData: [],
            studyPrograms: [],
            languages: [],
            documentTypes: [],
            certificateReasons: [],
            documentStatuses: [],

            requestsBySP: false,
            loading: true,

        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getRequests = this.getRequests.bind(this);
        this.getStudyPrograms = this.getStudyPrograms.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.fetchAll = this.fetchAll.bind(this);
    }

    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');

        let activeRole = localStorage.getItem('activeRole');
        window.localStorage.clear();
        localStorage.setItem('activeRole', activeRole);

        this.fetchAll();
        this.getStudyPrograms();
    }

    fetchAll() {
        axios.all([fetchLanguages(), fetchDocumentTypes(), fetchCertificateReasons(), fetchDocumentStatuses()])
            .then(axios.spread((languagesRes, documentTypeRes, certificateReasonRes, documentStatusRes) => {
                const languages = languagesRes.data;
                const documentTypes = documentTypeRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: (el.name === 'Prijava ispita' ? '' : el.name)
                }));
                const certificateReasons = certificateReasonRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale)
                        ? el.translations.find(e => e.language === window.$locale).name : el.name : el.name)
                }));
                const documentStatuses = documentStatusRes.data;
                this.setState({
                    languages, documentTypes, certificateReasons, documentStatuses
                });
                this.getRequests();
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch languages, document types or templates');
            });
    }

    getRequests() {
        let obj = {};
        axios.post('student-documents/requests-by-faculty', { ...obj })
            .then(res => {
                const dataa = res.data.map(el => ({
                    ...el,
                    id: el.documentRequestId,
                    documentType: this.state.documentTypes.find(e => e.id === el.documentTypeId).name,
                    certificateReason: !!el.certificateReasonId && this.state.certificateReasons.find(e => e.key === el.certificateReasonId).text,
                    status: this.state.documentStatuses.find(e => e.id === el.documentStatusId).name,
                    language: el.languageId ? this.state.languages.find(e => e.id === el.languageId).name : null,

                    date: moment(el.date).format('D. M. YYYY.'),
                    comment: el.comment,
                    processed: this.state.documentStatuses.find(e => e.id === el.documentStatusId).processed
                }
                ));
                this.setState({ data: dataa, requestsBySP: false, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch document requests');
            });
    }

    getStudyPrograms() {
        axios.get('study-programs/by-organizational-unit')
            .then(res => {
                const studyPrograms = res.data.filter(el => el.studyProgram.studyProgramStatus._key !== 'archived').map(el => ({
                    value: el.studyProgram.id, text: el.studyProgram.studyProgramBasic.name + ' - ' + el.studyProgram.name, key: el.studyProgram.id, description: el.studyCycles[0].name
                }));
                this.setState({ studyPrograms});
            })
            .catch(err => {
                console.log('Failed to fetch study programs');
            });
    }

    getDataToRender() {
        if (this.state.requestsBySP) {
            return this.state.filterData;
        }
        return this.state.data;
    }

    getFilterData(sProgramId) {
        let obj = {};
        axios.post(`student-documents/requests-by-study-program/${sProgramId}`, { ...obj })
            .then(res => {
                const filterData = res.data.map(el => ({
                    ...el,
                    id: el.documentRequestId,
                    documentType: this.state.documentTypes.find(e => e.id === el.documentTypeId).name,
                    certificateReason: !!el.certificateReasonId && this.state.certificateReasons.find(e => e.key === el.certificateReasonId).text,
                    status: this.state.documentStatuses.find(e => e.id === el.documentStatusId).name,
                    language: el.languageId ? this.state.languages.find(e => e.id === el.languageId).name : null,

                    date: moment(el.date).format('D. M. YYYY.'),
                    comment: el.comment,
                    processed: this.state.documentStatuses.find(e => e.id === el.documentStatusId).processed
                }
                ));
                this.setState({ filterData, requestsBySP: true });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    render() {
        const panes = [
            // {
            //     menuItem: 'Neobrađeni zahtjevi (fakultet)',
            //     render: () => (<Tab.Pane>
            //         <TableRequests
            //             data={this.getDataToRender().filter(el => !el.processed).reverse()}
            //             getRequests={this.getRequests}
            //             loading={this.state.loading}
            //             documentTypes={this.state.documentTypes}
            //             documentStatuses={this.state.documentStatuses}
            //             languages={this.state.languages}
            //             certificateReasons={this.state.certificateReasons}
            //             tabName="allRequests"
            //         /></Tab.Pane>)
            // },
            {
                menuItem: 'Neobrađeni zahtjevi',
                render: () => (<Tab.Pane>
                    <TableRequests
                        data={this.getDataToRender().filter(el => !el.processed).reverse()}
                        studyPrograms={this.state.studyPrograms}
                        getFilterData={this.getFilterData}
                        getRequests={this.getRequests}
                        loading={this.state.loading}
                        documentTypes={this.state.documentTypes}
                        documentStatuses={this.state.documentStatuses}
                        languages={this.state.languages}
                        certificateReasons={this.state.certificateReasons}
                        requestsBySP
                        tabName="SPRequests"
                    /></Tab.Pane>)

            },
            {
                menuItem: 'Obrađeni / poništeni zahtjevi',
                render: () => (<Tab.Pane>
                    <TableRequests
                        data={this.getDataToRender().filter(el => el.processed)}
                        getRequests={this.getRequests}
                        loading={this.state.loading}
                        documentTypes={this.state.documentTypes}
                        documentStatuses={this.state.documentStatuses}
                        languages={this.state.languages}
                        certificateReasons={this.state.certificateReasons}
                        processed
                        tabName="processedRequests"
                    /></Tab.Pane>)
            }];
        return (
            <div>
                <Header as="h1">Zahtjevi za dokumente</Header>

                <Segment.Group raised>
                    <Segment><h3>Spisak zahtjeva</h3></Segment>
                    <Segment><Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} /></Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/DocumentRequests/DocumentRequests.js